const roomReducer = (state, action) => {
  switch (action.type) {
    case 'ROOM_UNLOAD':
      return {
        ...state,
        roomLoaded: false,
        room: null,
      };
    case 'ROOM_NO_TICKET':
      return {
        ...state,
        hasTicketAccess: false,
      };
    case 'ROOM_LOAD':
      return {
        ...state,
        roomLoaded: false,
        hasTicketAccess: true,
        roomProgress: true,
        roomError: null,
      };
    case 'ROOM_SUCCESS':
      return {
        ...state,
        roomProgress: false,
        hasTicketAccess: true,
        roomLoaded: true,
        room: action.room,
        currentEventId: action.room.currentEventId,
        roomError: null,
      };
    case 'CURRENT_EVENT':
      return {
        ...state,
        currentEvent: action.event,
      };
    case 'CHANGE_CURRENT_EVENT':
      return {
        ...state,
        currentEvent: action.currentEvent,
        currentEventId: action.currentEventId,
        room: {
          ...state.room,
          currentEvent: action.currentEvent,
          currentEventId: action.currentEventId,
        },
      };

    case 'MODERATOR_VIEW_UPDATED':
      return {
        ...state,
        room: { ...state.room, moderator_view: action.moderator_view },
      };
    case 'ROOM_ERROR':
      return {
        ...state,
        roomProgress: false,
        roomLoaded: true,
        roomError: action.error,
      };

    case 'CURRENT_POLL_UPDATE_SUCCESS':
      return {
        ...state,
        room: {
          ...state.room,
          currentPollId: action.poll ? action.poll.id : null,
          currentPoll: action.poll,
        },
      };
    case 'DISPLAY_POLL_UPDATE_SUCCESS':
      return {
        ...state,
        room: {
          ...state.room,
          displayPollId: action.poll ? action.poll.id : null,
          displayPoll: action.poll,
        },
      };
    case 'ROOM_NEW_MODERATOR_MSG':
      return {
        ...state,
        room: {
          ...state.room,
          chatMessages: [action.msg, ...state.room.chatMessages],
        },
      };
    case 'ROOM_MSG_PINNED': {
      const msgIndex = state.room.chatMessages.findIndex(
        (m) => m.id === action.msg.id
      );
      if (msgIndex >= 0) {
        const newMessages = [...state.room.chatMessages];
        newMessages[msgIndex].pinned = action.msg.pinned;
        return {
          ...state,
          room: {
            ...state.room,
            chatMessages: newMessages,
          },
        };
      } else {
        return state;
      }
    }
    case 'REACTION_PROGRESS':
      return {
        ...state,
        timeReactionProgress: true,
        timeReactionSuccess: false,
        timeReaction: null,
        timeReactionError: null,
      };
    case 'REACTION_SUCCESS':
      return {
        ...state,
        timeReactionProgress: false,
        timeReactionSuccess: true,
        timeReaction: action.reaction,
      };
    case 'REACTION_ERROR':
      return {
        ...state,
        timeReactionProgress: false,
        timeReactionSuccess: false,
        timeReaction: null,
        timeReactionError: action.error,
      };
    default:
      return state;
  }
};

export default roomReducer;
